<div class="account-menu-page container-fluid py-4 px-3 px-md-4 px-lg-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">
      <app-account-settings-nav [fullWidth]="true"></app-account-settings-nav>
    </div>
  </div>
</div>
